
import Vue, { PropType } from "vue";

class Selector {
  public id!: string;
  public label!: string;

  public constructor(init?: Partial<Selector>) {
    Object.assign(this, init);
  }
}
export default Vue.extend({
  name: "SingleSelect",
  props: {
    options: {
      type: Array as PropType<Selector[]>,
      default: () => [],
    },
    title: { type: String, default: "" },
    name: { type: String, default: "" },
    errors: { type: Boolean, default: false },
    warning: { type: Boolean, default: false },
    selection: { type: [Boolean, Object], default: false },
    arialabel: { type: String, default: "" },
    customH: { type: String, default: "" },
    allowEmpty: { type: Boolean, default: false },
    diffKey: { type: String, default: "" },
    disabled: {
      type: Boolean,
      default: false,
    },
    useId: {
      type: Boolean,
      default: false,
    },
    useLabelCombination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      selected: {} as Selector,
      show: false,
    };
  },
  watch: {
    selection(newVal) {
      if (newVal) {
        this.select(newVal);
      }
    },
  },
  mounted() {
    if (this.options) {
      if (this.allowEmpty) {
        this.show = true;
        this.selected = { id: "", label: "-" };
      } else {
        this.selected = this.options[0];
      }
    }
    if (this.selection) {
      this.select(this.selection);
    }
  },
  methods: {
    onShow() {
      this.isOpen = !this.isOpen;
    },
    close() {
      this.isOpen = false;
    },
    select(item: Selector) {
      this.selected = item;
      this.show = true;
      this.isOpen = false;
      this.$emit("selectedItem", item);
      if (this.name || item) {
        this.$emit("selectionMade", {
          option: item,
          name: this.name ? this.name : this.title,
        });
      }
    },
  },
});
